<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="itemPrixSpecial">
     
        <h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps">{{collaps == true ? '-' : '+'}} {{$t('i_PrixSpecial')}}</h6>
            <span v-show="collaps">
                <s-duoSelector style="margin-left: -15px" :text1="$t('i_Montant')" :text2="$t('i_Pourcent')" :value="_IsSpecialPricePercent" :returnValue.sync="_IsSpecialPricePercent"></s-duoSelector>

                <!--Rabais-->
                <b-row align-v="center">
                    <b-col cols="5" xl="4">
                        <b-row align-v="center">
                            <span v-if="_IsSpecialPricePercent==false">
                                <s-currencyInput class="PrixS" append="$" v-model="_SpecialPrice"></s-currencyInput>
                            </span>
                            <span v-else>
                                <s-currencyInput class="PrixS" append="%" v-model="_SpecialPrice"></s-currencyInput>
                            </span>
                        </b-row>
                    </b-col>
                </b-row>

                <b-form-checkbox switch class="MargeTop5" :size="chkSize" v-model="_IsSpecialPriceNoDate">{{$t('i_Indefini')}}</b-form-checkbox>

                <b-row align-v="center" class="txtPrincipal">
                    <b-col v-show="!_IsSpecialPriceNoDate" cols="12" xl="10">
                        <b-form-datepicker id="date_fin" :state="true" v-model="_SpecialPriceDate"></b-form-datepicker>
                    </b-col>
                </b-row>

                <b-button class="MargeTop10" id="deletePrixS" name="deletePrixS" :variant="getTheme.danger" @click="deletePrice()">{{$t('g_Supprimer')}}</b-button>
                
            </span>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemPrixSpecial',
    components: {

    },
    props: ['isSpecialPricePercent', 'specialPrice', 'isSpecialPriceNoDate', 'specialPriceDate', 'chkSize'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {
        deletePrice () {
            this.$emit('deletePrice')
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
        _IsSpecialPricePercent: {
            get: function() {return this.isSpecialPricePercent},
            set: function(modifiedValue){this.$emit('update:isSpecialPricePercent', modifiedValue)}
        },
        _SpecialPrice: {
            get: function() {return this.specialPrice},
            set: function(modifiedValue){this.$emit('update:specialPrice', modifiedValue)}
        },
        _IsSpecialPriceNoDate: {
            get: function() {return this.isSpecialPriceNoDate},
            set: function(modifiedValue){this.$emit('update:isSpecialPriceNoDate', modifiedValue)}
        },
        _SpecialPriceDate: {
            get: function() {return this.specialPriceDate == "1970-01-01T12:00:00" ? "" : this.specialPriceDate },
            set: function(modifiedValue){this.$emit('update:specialPriceDate', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>

</style>